import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings<{
  badge: string;
}>({
  en: {
    badge: 'From Shine {planName}',
  },
  fr: {
    badge: 'À partir de Shine {planName}',
  },
} as const);

export default locales;
